import { PublicLayout } from "@/components/layout/PublicLayout";

const Presse = () => {
  return (
    <PublicLayout
      showHero={true}
      heroTitle="Presse"
      heroSubtitle="Presseinformationen und Medienressourcen"
      heroVariant="compact"
    >
      <div className="container mx-auto px-4 py-16">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-8">Inhalt wird in Kürze verfügbar sein</h2>
          <p className="text-gray-600">Diese Seite wird bald mit Inhalten gefüllt.</p>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Presse;